import { ShippingMethodTypes } from '@monofront/types';
import {
  DeliveryBarMachineContextShippingMethod,
  DeliveryBarMachineState,
} from './types';

export const machineContextSelector = (state: DeliveryBarMachineState) => {
  return state.context;
};

export const machineSelectedShippingFreshEligibleSelector = (
  state: DeliveryBarMachineState,
) => {
  return state.context.shippingMethod?.type === ShippingMethodTypes.COURIER;
};

export const machineSelectedShippingFandVEligibleSelector = (
  state: DeliveryBarMachineState,
) => {
  return state.context.shippingMethod?.type === ShippingMethodTypes.COURIER;
};

export const machineSelectedAddressSelector = (
  state: DeliveryBarMachineState,
) => {
  return state.context.address;
};

export const machineValueSelector = (state: DeliveryBarMachineState) => {
  return state.value;
};

export const machineShippingMethodsSelector = (
  state: DeliveryBarMachineState,
) => {
  return state.context.eligibleShippingMethods;
};

export const machineSelectedShippingMethodSelector = (
  state: DeliveryBarMachineState,
): DeliveryBarMachineContextShippingMethod | null => {
  return state.context.shippingMethod;
};
